/* Re-Tech: one-click deposit reservation from a build product page or card (snippet rt-build-deposit). */
(() => {
  if (window.__rtBuildDeposit) return;
  window.__rtBuildDeposit = true;
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-rt-bd-go]');
    if (!btn || btn.disabled) return;
    const box = btn.closest('[data-rt-bd]');
    const err = box.querySelector('.rt-bd-error');
    let d;
    try { d = JSON.parse(box.querySelector('[data-rt-bd-data]').textContent); } catch { return; }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const label = btn.innerHTML;
    btn.disabled = true; btn.textContent = d.wait; if (err) err.hidden = true;
    const props = {[d.k_build]: d.lines.join('\n'), [d.k_total]: d.total, [d.k_link]: d.link, _rc2: d.rc2};
    if (d.xk) props[d.xk] = d.xv;
    try {
      const cart = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}}).then(r => r.json());
      for (const item of (cart.items || []).filter(x => x.variant_id === d.variant)) {
        await fetch(root + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: item.key, quantity: 0})});
      }
      const res = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: d.variant, quantity: 1, properties: props}]})});
      if (!res.ok) throw new Error('add ' + res.status);
      try { (window.dataLayer = window.dataLayer || []).push({event: 'rc2_configurator', rc2_action: 'build_deposit', rc2_label: d.preset, rc2_build_value: d.value}); } catch {}
      try { document.dispatchEvent(new CustomEvent('rt:build-deposit', {detail: {preset: d.preset, value: d.value, promo: d.xk || ''}})); } catch {}
      location.href = root + 'checkout';
    } catch (x) {
      btn.disabled = false; btn.innerHTML = label;
      if (err) err.hidden = false;
    }
  });
})();
